import { Scene } from 'phaser';

export class GameOverScene extends Scene {
  private score: number = 0;
  private wave: number = 0;

  constructor() {
    super({ key: 'GameOverScene' });
  }

  init(data: { score: number; wave: number }): void {
    this.score = data.score;
    this.wave = data.wave;
  }

  create(): void {
    const { width, height } = this.cameras.main;

    this.add.text(width / 2, height / 3, 'GAME OVER', {
      fontSize: '36px',
      fontFamily: 'Courier New',
      color: '#ff0000',
      align: 'center'
    }).setOrigin(0.5);

    this.add.text(width / 2, height / 2 - 40, `Wave: ${this.wave}`, {
      fontSize: '20px',
      fontFamily: 'Courier New',
      color: '#ffffff',
      align: 'center'
    }).setOrigin(0.5);

    this.add.text(width / 2, height / 2, `Score: ${this.score}`, {
      fontSize: '20px',
      fontFamily: 'Courier New',
      color: '#ffffff',
      align: 'center'
    }).setOrigin(0.5);

    const restartButton = this.add.text(width / 2, height / 2 + 60, 'RESTART', {
      fontSize: '24px',
      fontFamily: 'Courier New',
      color: '#ffffff',
      backgroundColor: '#00ffff',
      padding: { x: 20, y: 10 }
    }).setOrigin(0.5);

    const menuButton = this.add.text(width / 2, height / 2 + 120, 'MENU', {
      fontSize: '20px',
      fontFamily: 'Courier New',
      color: '#ffffff',
      backgroundColor: '#888888',
      padding: { x: 15, y: 8 }
    }).setOrigin(0.5);

    restartButton.setInteractive({ useHandCursor: true });
    restartButton.on('pointerdown', () => this.restartGame());
    restartButton.on('pointerover', () => restartButton.setStyle({ color: '#00ffff' }));
    restartButton.on('pointerout', () => restartButton.setStyle({ color: '#ffffff' }));

    menuButton.setInteractive({ useHandCursor: true });
    menuButton.on('pointerdown', () => this.returnToMenu());
    menuButton.on('pointerover', () => menuButton.setStyle({ color: '#00ffff' }));
    menuButton.on('pointerout', () => menuButton.setStyle({ color: '#ffffff' }));
  }

  private restartGame(): void {
    this.scene.start('GameScene');
  }

  private returnToMenu(): void {
    this.scene.start('MenuScene');
  }
}